import { FC, useCallback, useState } from "react";
import AuthMpProvider from "@/core/data-provider/data-mp/auth/auth-mp-provider";
import useSignInPin from "@/domains/auth/hooks/useSignInPin.ts";
import AuthUpdatePin from "@/domains/auth/components/update/AuthUpdatePin.tsx";

interface AuthCreatePinContainerProps {}

const AuthCreatePinContainer: FC<AuthCreatePinContainerProps> = function AuthCreatePinContainer() {
  const [pin, setPin] = useState<string>("");
  const [pinRepeat, setPinRepeat] = useState<string>("");
  const { pending, error, setError, onSubmit } = useSignInPin();

  const onPinChangeHandler = useCallback(
    (value: string) => {
      setPin(value);
      setError("");
    },
    [setError],
  );

  const onNonMatchedHandler = useCallback(() => {
    setError("Пин-коды не совпадают");
  }, [setError]);

  const onPinRepeatChangeHandler = useCallback(
    (value: string) => {
      setPinRepeat(value);
      setError("");
    },
    [setError],
  );

  const onSubmitHandler = useCallback(async () => {
    await onSubmit(pin);
    await AuthMpProvider.goToAccount();
  }, [onSubmit, pin]);

  return (
    <AuthUpdatePin
      title="Установка пин-кода"
      pin={pin}
      onPinChange={onPinChangeHandler}
      pinRepeat={pinRepeat}
      onNotMatched={onNonMatchedHandler}
      onPinRepeatChange={onPinRepeatChangeHandler}
      onSubmit={onSubmitHandler}
      pending={pending}
      error={error}
    />
  );
};

export default AuthCreatePinContainer;
